<template>
  <div class="col-12">
    <div class="table-responsive">
      <table class="table table-hover align-middle">
        <thead>
          <tr>
            <th>İş Adı</th>
            <th>Periyot</th>
            <th>Sonraki Tarih</th>
            <th>Durum</th>
            <th class="text-end">İşlem</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in paginatedItems" :key="item.id">
            <td>
              <div class="fw-semibold">{{ item.ad }}</div>
              <div class="text-muted text-small">{{ item.aciklama || "-" }}</div>
            </td>
            <td>{{ item.periyot === "haftalik" ? "Haftalık" : "Aylık" }}</td>
            <td>{{ formatTarihKisa(item.sonraki_tarih) }}</td>
            <td>
              <span class="badge" :class="item.aktif == 1 ? 'bg-success' : 'bg-outline-muted'">
                {{ item.aktif == 1 ? "Aktif" : "Pasif" }}
              </span>
            </td>
            <td class="text-end">
              <button class="btn btn-sm btn-outline-primary me-2" @click="duzenle(item)">Düzenle</button>
              <button class="btn btn-sm btn-outline-danger" @click="sil(item.id)">Sil</button>
            </td>
          </tr>
          <tr v-if="!paginatedItems.length">
            <td colspan="5" class="text-center text-muted py-4">Kayıt bulunamadı.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="d-flex justify-content-between align-items-center mt-3">
      <div>
        <select class="form-select form-select-sm" style="width: 120px" :value="tekrarEdenIsler.sayfadaKayit" @change="sayfadaKayitDegistir(Number($event.target.value))">
          <option :value="5">5 adet</option>
          <option :value="10">10 adet</option>
          <option :value="20">20 adet</option>
        </select>
      </div>
      <ul class="pagination pagination-sm mb-0">
        <li class="page-item" :class="{ active: page === tekrarEdenIsler.seciliSayfa }" v-for="page in pages" :key="page">
          <a class="page-link" @click="sayfaDegistir(page)">{{ page }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import axiosCustom from "@/services/axiosCustom";
import { formatTarihKisa } from "@/services/globalVariable";

export default {
  props: {
    tekrarEdenIsler: {
      type: Object,
      required: true,
    },
    duzenle: Function,
    formKaydetSonrasi: Function,
  },
  computed: {
    filteredItems() {
      const keyword = (this.tekrarEdenIsler.arananKelime || "").toLowerCase();
      return (this.tekrarEdenIsler.tumu || []).filter((item) => {
        return (
          !keyword ||
          (item.ad && item.ad.toLowerCase().includes(keyword)) ||
          (item.aciklama && item.aciklama.toLowerCase().includes(keyword))
        );
      });
    },
    paginatedItems() {
      const start = (this.tekrarEdenIsler.seciliSayfa - 1) * this.tekrarEdenIsler.sayfadaKayit;
      const end = start + this.tekrarEdenIsler.sayfadaKayit;
      return this.filteredItems.slice(start, end);
    },
    totalPages() {
      const total = Math.ceil(this.filteredItems.length / this.tekrarEdenIsler.sayfadaKayit);
      return Math.max(total, 1);
    },
    pages() {
      return Array.from({ length: this.totalPages }, (_, i) => i + 1);
    },
  },
  methods: {
    formatTarihKisa,
    sayfaDegistir(page) {
      this.$emit("update:tekrarEdenIsler", {
        ...this.tekrarEdenIsler,
        seciliSayfa: page,
      });
    },
    sayfadaKayitDegistir(value) {
      this.$emit("update:tekrarEdenIsler", {
        ...this.tekrarEdenIsler,
        sayfadaKayit: value,
        seciliSayfa: 1,
      });
    },
    async sil(id) {
      const result = await this.$swal({
        title: "Emin misiniz?",
        text: "Bu tanım silinecek.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Evet, sil",
        cancelButtonText: "İptal",
      });
      if (!result.isConfirmed) return;

      try {
        await axiosCustom.post(`musteriler/tekraredenissil/${id}`);
        this.$toast.success("Tekrar eden iş silindi");
        this.formKaydetSonrasi();
      } catch (error) {
        this.$toast.error("Silme hatası");
      }
    },
  },
};
</script>
